"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skip = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Clickable = require("../Clickable");

var _Text = require("../Text");

var _VisuallyHidden = require("../VisuallyHidden");

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = (0, _styledComponents.default)(_Clickable.Clickable).withConfig({
  displayName: "Skip__Container",
  componentId: "o4qt2-0"
})(["display:block;text-decoration:underline;outline:0;&:not(:focus):not(:active){", "}"], _VisuallyHidden.visuallyHiddenMixin);
/**
 * Either a button or an anchor tag
 */

/**
 * Skip link or button.
 * Utilize `as="a"` for an anchor tag to link to landmark IDs.
 * Used, for example, to skip to content in the nav.
 * Is visually hidden until focused, which reveals it.
 */
var Skip = /*#__PURE__*/_react.default.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: forwardedRef,
    display: "block",
    bg: "black10"
  }, rest), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    p: 1,
    variant: "text"
  }, children));
});

exports.Skip = Skip;
//# sourceMappingURL=Skip.js.map